var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"footer-inner"},[_vm._v("Copyright © みどり求人ナビ")])])
}]

export { render, staticRenderFns }